import { todayISO } from "../../lib/api";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const ZIP_RE = /^\d{5}$/;
const digits = (s) => (s || "").replace(/\D/g, "").length;

export const initialForm = (q) => ({
  customer: { full_name: "", email: "", phone: "", company: "" },
  item: {
    item_type: q.get("item_type") || "sedan", year: "", make: "", model: "", vin: "",
    operable: q.get("operable") !== "false", transport_type: q.get("transport_type") || "open",
    description: "", weight_lbs: "", dimensions: "", expedited: q.get("expedited") === "true",
  },
  pickup: { address: "", zip: q.get("pickup_zip") || "", contact_name: "", contact_phone: "" },
  delivery: { address: "", zip: q.get("delivery_zip") || "", contact_name: "", contact_phone: "", location_type: "residence" },
  pickup_date: "",
  notes: "",
});

export const validateStep = (step, f) => {
  const e = {};
  if (step === 0) {
    const c = f.customer;
    if (c.full_name.trim().length < 2) e["customer.full_name"] = "Full name is required.";
    if (!EMAIL_RE.test(c.email.trim())) e["customer.email"] = "Enter a valid email address.";
    if (digits(c.phone) < 10) e["customer.phone"] = "Enter a valid phone number (10+ digits).";
  }
  if (step === 1) {
    const it = f.item;
    if (it.item_type === "freight") {
      if (!it.description.trim()) e["item.description"] = "Describe the freight.";
      if (it.weight_lbs && !(Number(it.weight_lbs) > 0)) e["item.weight_lbs"] = "Weight must be a positive number.";
    } else {
      const y = Number(it.year);
      if (!y || y < 1900 || y > new Date().getFullYear() + 1) e["item.year"] = "Enter a valid year.";
      if (!it.make.trim()) e["item.make"] = "Make is required.";
      if (!it.model.trim()) e["item.model"] = "Model is required.";
      if (it.vin && it.vin.length > 17) e["item.vin"] = "VIN is at most 17 characters.";
    }
  }
  if (step === 2) {
    ["pickup", "delivery"].forEach((k) => {
      const s = f[k];
      if (s.address.trim().length < 3) e[`${k}.address`] = "Street address is required.";
      if (!ZIP_RE.test(s.zip)) e[`${k}.zip`] = "Enter a valid 5-digit ZIP.";
      if (s.contact_name.trim().length < 2) e[`${k}.contact_name`] = "Contact name is required.";
      if (digits(s.contact_phone) < 7) e[`${k}.contact_phone`] = "Contact phone is required.";
    });
    if (!f.pickup_date) e.pickup_date = "Choose a preferred pickup date.";
    else if (f.pickup_date < todayISO()) e.pickup_date = "Pickup date cannot be in the past.";
  }
  return e;
};

export const toPayload = (f) => {
  const it = f.item;
  const freight = it.item_type === "freight";
  const opt = (v) => (v && String(v).trim()) || null;
  return {
    customer: { ...f.customer, company: opt(f.customer.company) },
    item: {
      item_type: it.item_type, transport_type: it.transport_type, expedited: it.expedited,
      operable: freight ? true : it.operable,
      year: freight ? null : Number(it.year), make: freight ? null : it.make.trim(), model: freight ? null : it.model.trim(),
      vin: freight ? null : opt(it.vin),
      description: freight ? it.description.trim() : null,
      weight_lbs: freight && it.weight_lbs ? Number(it.weight_lbs) : null,
      dimensions: freight ? opt(it.dimensions) : null,
    },
    pickup: f.pickup,
    delivery: f.delivery,
    pickup_date: f.pickup_date,
    notes: opt(f.notes),
  };
};
